import { createContext, useContext, useState } from 'react';
import LeagueStructure from "./leagueStructure.json";
// import TeamList from "./teamList.json"
import LeagueElo from "./leagueElo.json";

const Cxt = createContext();

export const LeagueStructureProvider = ({ children }) => {
  const [leagueStructure, setLeagueStructure] = useState(LeagueStructure);
	// const [teamList, setTeamList] = useState(TeamList);
	const [leagueElo, setLeagueElo] = useState(LeagueElo);
	
	const updateLeagueStructure = newData => {
		setLeagueStructure(newData);
	}
	
	// const updateTeamList = newData => {
	// 	setTeamList(newData);
	// }

  return (
    <Cxt.Provider value={{ leagueStructure, updateLeagueStructure, leagueElo, setLeagueElo }}>
      {children}
    </Cxt.Provider>
  );
};

export const useCxt = () => {
  return useContext(Cxt);
};
